export const Countries = [
  { location: 'Afghanistan', continent: 'Asia', id: 65544 },
  { location: 'Albania', continent: 'Europe', id: 56201 },
  { location: 'Algeria', continent: 'Africa', id: 67675 },
  { location: 'American Samoa', continent: 'Oceania', id: 28003 },
  { location: 'Andorra', continent: 'Europe', id: 18847 },
  { location: 'Angola', continent: 'Africa', id: 44124 },
  { location: 'Anguilla', continent: 'North America', id: 16871 },
  { location: 'Antarctica', continent: 'Antarctica', id: 62095 },
  { location: 'Antigua and Barbuda', continent: 'North America', id: 73993 },
  { location: 'Argentina', continent: 'South America', id: 97745 },
  { location: 'Armenia', continent: 'Asia', id: 93244 },
  { location: 'Aruba', continent: 'North America', id: 12518 },
  { location: 'Australia', continent: 'Oceania', id: 6868 },
  { location: 'Austria', continent: 'Europe', id: 14182 },
  { location: 'Azerbaijan', continent: 'Asia', id: 28341 },
  { location: 'Bahamas', continent: 'North America', id: 47121 },
  { location: 'Bahrain', continent: 'Asia', id: 22237 },
  { location: 'Bangladesh', continent: 'Asia', id: 19438 },
  { location: 'Barbados', continent: 'North America', id: 88645 },
  { location: 'Belarus', continent: 'Europe', id: 85909 },
  { location: 'Belgium', continent: 'Europe', id: 42179 },
  { location: 'Belize', continent: 'North America', id: 17047 },
  { location: 'Benin', continent: 'Africa', id: 6311 },
  { location: 'Bermuda', continent: 'North America', id: 28861 },
  { location: 'Bhutan', continent: 'Asia', id: 74225 },
  { location: 'Bolivia', continent: 'South America', id: 46775 },
  { location: 'Bosnia and Herzegovina', continent: 'Europe', id: 91902 },
  { location: 'Botswana', continent: 'Africa', id: 48235 },
  { location: 'Bouvet Island', continent: 'Antarctica', id: 28576 },
  { location: 'Brazil', continent: 'South America', id: 64248 },
  { location: 'British Indian Ocean Territory', continent: 'Africa', id: 7463 },
  { location: 'Brunei', continent: 'Asia', id: 45565 },
  { location: 'Bulgaria', continent: 'Europe', id: 69669 },
  { location: 'Burkina Faso', continent: 'Africa', id: 65868 },
  { location: 'Burundi', continent: 'Africa', id: 16536 },
  { location: 'Cambodia', continent: 'Asia', id: 81694 },
  { location: 'Cameroon', continent: 'Africa', id: 84793 },
  { location: 'Canada', continent: 'North America', id: 6418 },
  { location: 'Cape Verde', continent: 'Africa', id: 69385 },
  { location: 'Cayman Islands', continent: 'North America', id: 95972 },
  { location: 'Central African Republic', continent: 'Africa', id: 45364 },
  { location: 'Chad', continent: 'Africa', id: 90351 },
  { location: 'Chile', continent: 'South America', id: 84107 },
  { location: 'China', continent: 'Asia', id: 72917 },
  { location: 'Christmas Island', continent: 'Oceania', id: 55177 },
  { location: 'Cocos (Keeling) Islands', continent: 'Oceania', id: 71794 },
  { location: 'Colombia', continent: 'South America', id: 3966 },
  { location: 'Comoros', continent: 'Africa', id: 69696 },
  { location: 'Congo', continent: 'Africa', id: 89974 },
  { location: 'Cook Islands', continent: 'Oceania', id: 81386 },
  { location: 'Costa Rica', continent: 'North America', id: 43717 },
  { location: 'Croatia', continent: 'Europe', id: 56179 },
  { location: 'Cuba', continent: 'North America', id: 62420 },
  { location: 'Cyprus', continent: 'Asia', id: 10678 },
  { location: 'Czech Republic', continent: 'Europe', id: 58762 },
  { location: 'Denmark', continent: 'Europe', id: 93561 },
  { location: 'Djibouti', continent: 'Africa', id: 43384 },
  { location: 'Dominica', continent: 'North America', id: 65627 },
  { location: 'Dominican Republic', continent: 'North America', id: 43508 },
  { location: 'East Timor', continent: 'Asia', id: 12764 },
  { location: 'Ecuador', continent: 'South America', id: 9585 },
  { location: 'Egypt', continent: 'Africa', id: 88722 },
  { location: 'El Salvador', continent: 'North America', id: 97107 },
  { location: 'England', continent: 'Europe', id: 48766 },
  { location: 'Equatorial Guinea', continent: 'Africa', id: 67062 },
  { location: 'Eritrea', continent: 'Africa', id: 97692 },
  { location: 'Estonia', continent: 'Europe', id: 46734 },
  { location: 'Ethiopia', continent: 'Africa', id: 88755 },
  { location: 'Falkland Islands', continent: 'South America', id: 45124 },
  { location: 'Faroe Islands', continent: 'Europe', id: 33877 },
  { location: 'Fiji Islands', continent: 'Oceania', id: 78129 },
  { location: 'Finland', continent: 'Europe', id: 98053 },
  { location: 'France', continent: 'Europe', id: 84383 },
  { location: 'French Guiana', continent: 'South America', id: 75863 },
  { location: 'French Polynesia', continent: 'Oceania', id: 45074 },
  { location: 'French Southern territories', continent: 'Antarctica', id: 61499 },
  { location: 'Gabon', continent: 'Africa', id: 96789 },
  { location: 'Gambia', continent: 'Africa', id: 68485 },
  { location: 'Georgia', continent: 'Asia', id: 99639 },
  { location: 'Germany', continent: 'Europe', id: 58062 },
  { location: 'Ghana', continent: 'Africa', id: 26787 },
  { location: 'Gibraltar', continent: 'Europe', id: 83136 },
  { location: 'Greece', continent: 'Europe', id: 74039 },
  { location: 'Greenland', continent: 'North America', id: 4517 },
  { location: 'Grenada', continent: 'North America', id: 24525 },
  { location: 'Guadeloupe', continent: 'North America', id: 17567 },
  { location: 'Guam', continent: 'Oceania', id: 92835 },
  { location: 'Guatemala', continent: 'North America', id: 88027 },
  { location: 'Guinea', continent: 'Africa', id: 57154 },
  { location: 'Guinea-Bissau', continent: 'Africa', id: 72911 },
  { location: 'Guyana', continent: 'South America', id: 68650 },
  { location: 'Haiti', continent: 'North America', id: 73731 },
  { location: 'Heard Island and McDonald Islands', continent: 'Antarctica', id: 75858 },
  { location: 'Holy See (Vatican City State)', continent: 'Europe', id: 85731 },
  { location: 'Honduras', continent: 'North America', id: 99575 },
  { location: 'Hong Kong', continent: 'Asia', id: 34207 },
  { location: 'Hungary', continent: 'Europe', id: 80481 },
  { location: 'Iceland', continent: 'Europe', id: 24580 },
  { location: 'India', continent: 'Asia', id: 9622 },
  { location: 'Indonesia', continent: 'Asia', id: 73366 },
  { location: 'Iran', continent: 'Asia', id: 94992 },
  { location: 'Iraq', continent: 'Asia', id: 51372 },
  { location: 'Ireland', continent: 'Europe', id: 2355 },
  { location: 'Israel', continent: 'Asia', id: 67656 },
  { location: 'Italy', continent: 'Europe', id: 29220 },
  { location: 'Ivory Coast', continent: 'Africa', id: 81087 },
  { location: 'Jamaica', continent: 'North America', id: 25546 },
  { location: 'Japan', continent: 'Asia', id: 69411 },
  { location: 'Jordan', continent: 'Asia', id: 18894 },
  { location: 'Kazakhstan', continent: 'Asia', id: 69758 },
  { location: 'Kenya', continent: 'Africa', id: 59906 },
  { location: 'Kiribati', continent: 'Oceania', id: 37160 },
  { location: 'Kuwait', continent: 'Asia', id: 68967 },
  { location: 'Kyrgyzstan', continent: 'Asia', id: 91727 },
  { location: 'Laos', continent: 'Asia', id: 27597 },
  { location: 'Latvia', continent: 'Europe', id: 53166 },
  { location: 'Lebanon', continent: 'Asia', id: 85418 },
  { location: 'Lesotho', continent: 'Africa', id: 35463 },
  { location: 'Liberia', continent: 'Africa', id: 75159 },
  { location: 'Libyan Arab Jamahiriya', continent: 'Africa', id: 19123 },
  { location: 'Liechtenstein', continent: 'Europe', id: 98709 },
  { location: 'Lithuania', continent: 'Europe', id: 15330 },
  { location: 'Luxembourg', continent: 'Europe', id: 80551 },
  { location: 'Macao', continent: 'Asia', id: 18857 },
  { location: 'North Macedonia', continent: 'Europe', id: 30506 },
  { location: 'Madagascar', continent: 'Africa', id: 63783 },
  { location: 'Malawi', continent: 'Africa', id: 57653 },
  { location: 'Malaysia', continent: 'Asia', id: 64819 },
  { location: 'Maldives', continent: 'Asia', id: 28548 },
  { location: 'Mali', continent: 'Africa', id: 70355 },
  { location: 'Malta', continent: 'Europe', id: 8740 },
  { location: 'Marshall Islands', continent: 'Oceania', id: 27004 },
  { location: 'Martinique', continent: 'North America', id: 54014 },
  { location: 'Mauritania', continent: 'Africa', id: 59954 },
  { location: 'Mauritius', continent: 'Africa', id: 27266 },
  { location: 'Mayotte', continent: 'Africa', id: 76776 },
  { location: 'Mexico', continent: 'North America', id: 90118 },
  { location: 'Micronesia, Federated States of', continent: 'Oceania', id: 97975 },
  { location: 'Moldova', continent: 'Europe', id: 19504 },
  { location: 'Monaco', continent: 'Europe', id: 26559 },
  { location: 'Mongolia', continent: 'Asia', id: 88259 },
  { location: 'Montenegro', continent: 'Europe', id: 98774 },
  { location: 'Montserrat', continent: 'North America', id: 5748 },
  { location: 'Morocco', continent: 'Africa', id: 88618 },
  { location: 'Mozambique', continent: 'Africa', id: 56081 },
  { location: 'Myanmar', continent: 'Asia', id: 35377 },
  { location: 'Namibia', continent: 'Africa', id: 26490 },
  { location: 'Nauru', continent: 'Oceania', id: 14526 },
  { location: 'Nepal', continent: 'Asia', id: 30482 },
  { location: 'Netherlands', continent: 'Europe', id: 38688 },
  { location: 'Netherlands Antilles', continent: 'North America', id: 77967 },
  { location: 'New Caledonia', continent: 'Oceania', id: 84423 },
  { location: 'New Zealand', continent: 'Oceania', id: 91369 },
  { location: 'Nicaragua', continent: 'North America', id: 96547 },
  { location: 'Niger', continent: 'Africa', id: 1923 },
  { location: 'Nigeria', continent: 'Africa', id: 92957 },
  { location: 'Niue', continent: 'Oceania', id: 30548 },
  { location: 'Norfolk Island', continent: 'Oceania', id: 4798 },
  { location: 'North Korea', continent: 'Asia', id: 57293 },
  { location: 'Northern Ireland', continent: 'Europe', id: 79532 },
  { location: 'Northern Mariana Islands', continent: 'Oceania', id: 22542 },
  { location: 'Norway', continent: 'Europe', id: 99773 },
  { location: 'Oman', continent: 'Asia', id: 49895 },
  { location: 'Pakistan', continent: 'Asia', id: 51797 },
  { location: 'Palau', continent: 'Oceania', id: 26464 },
  { location: 'Palestine', continent: 'Asia', id: 2869 },
  { location: 'Panama', continent: 'North America', id: 97994 },
  { location: 'Papua New Guinea', continent: 'Oceania', id: 36517 },
  { location: 'Paraguay', continent: 'South America', id: 6959 },
  { location: 'Peru', continent: 'South America', id: 87121 },
  { location: 'Philippines', continent: 'Asia', id: 23298 },
  { location: 'Pitcairn', continent: 'Oceania', id: 54045 },
  { location: 'Poland', continent: 'Europe', id: 52974 },
  { location: 'Portugal', continent: 'Europe', id: 92196 },
  { location: 'Puerto Rico', continent: 'North America', id: 29533 },
  { location: 'Qatar', continent: 'Asia', id: 17604 },
  { location: 'Reunion', continent: 'Africa', id: 31989 },
  { location: 'Romania', continent: 'Europe', id: 3413 },
  { location: 'Russian Federation', continent: 'Europe', id: 75723 },
  { location: 'Rwanda', continent: 'Africa', id: 98530 },
  { location: 'Saint Helena', continent: 'Africa', id: 33983 },
  { location: 'Saint Kitts and Nevis', continent: 'North America', id: 45316 },
  { location: 'Saint Lucia', continent: 'North America', id: 89362 },
  { location: 'Saint Pierre and Miquelon', continent: 'North America', id: 12900 },
  { location: 'Saint Vincent and the Grenadines', continent: 'North America', id: 12836 },
  { location: 'Samoa', continent: 'Oceania', id: 25870 },
  { location: 'San Marino', continent: 'Europe', id: 11800 },
  { location: 'Sao Tome and Principe', continent: 'Africa', id: 88998 },
  { location: 'Saudi Arabia', continent: 'Asia', id: 77499 },
  { location: 'Scotland', continent: 'Europe', id: 57049 },
  { location: 'Senegal', continent: 'Africa', id: 67993 },
  { location: 'Seychelles', continent: 'Africa', id: 18759 },
  { location: 'Sierra Leone', continent: 'Africa', id: 3871 },
  { location: 'Singapore', continent: 'Asia', id: 68299 },
  { location: 'Slovakia', continent: 'Europe', id: 62900 },
  { location: 'Slovenia', continent: 'Europe', id: 85989 },
  { location: 'Solomon Islands', continent: 'Oceania', id: 26124 },
  { location: 'Somalia', continent: 'Africa', id: 54482 },
  { location: 'South Africa', continent: 'Africa', id: 94698 },
  { location: 'South Georgia and the South Sandwich Islands', continent: 'Antarctica', id: 4290 },
  { location: 'South Korea', continent: 'Asia', id: 71711 },
  { location: 'South Sudan', continent: 'Africa', id: 7086 },
  { location: 'Spain', continent: 'Europe', id: 79290 },
  { location: 'Sri Lanka', continent: 'Asia', id: 6011 },
  { location: 'Sudan', continent: 'Africa', id: 48233 },
  { location: 'Suriname', continent: 'South America', id: 21427 },
  { location: 'Svalbard and Jan Mayen', continent: 'Europe', id: 7750 },
  { location: 'Swaziland', continent: 'Africa', id: 5811 },
  { location: 'Sweden', continent: 'Europe', id: 54863 },
  { location: 'Switzerland', continent: 'Europe', id: 54540 },
  { location: 'Syria', continent: 'Asia', id: 74616 },
  { location: 'Tajikistan', continent: 'Asia', id: 64335 },
  { location: 'Tanzania', continent: 'Africa', id: 9991 },
  { location: 'Thailand', continent: 'Asia', id: 38711 },
  { location: 'The Democratic Republic of Congo', continent: 'Africa', id: 53777 },
  { location: 'Togo', continent: 'Africa', id: 45783 },
  { location: 'Tokelau', continent: 'Oceania', id: 6725 },
  { location: 'Tonga', continent: 'Oceania', id: 52257 },
  { location: 'Trinidad and Tobago', continent: 'North America', id: 44640 },
  { location: 'Tunisia', continent: 'Africa', id: 91420 },
  { location: 'Turkey', continent: 'Asia', id: 34419 },
  { location: 'Turkmenistan', continent: 'Asia', id: 35845 },
  { location: 'Turks and Caicos Islands', continent: 'North America', id: 34112 },
  { location: 'Tuvalu', continent: 'Oceania', id: 92051 },
  { location: 'Uganda', continent: 'Africa', id: 89126 },
  { location: 'Ukraine', continent: 'Europe', id: 24530 },
  { location: 'United Arab Emirates', continent: 'Asia', id: 67508 },
  { location: 'United Kingdom', continent: 'Europe', id: 5480 },
  { location: 'US', continent: 'North America', id: 51835 },
  { location: 'United States Minor Outlying Islands', continent: 'Oceania', id: 38399 },
  { location: 'Uruguay', continent: 'South America', id: 7979 },
  { location: 'Uzbekistan', continent: 'Asia', id: 55872 },
  { location: 'Vanuatu', continent: 'Oceania', id: 79923 },
  { location: 'Venezuela', continent: 'South America', id: 75542 },
  { location: 'Vietnam', continent: 'Asia', id: 66044 },
  { location: 'Virgin Islands, British', continent: 'North America', id: 68580 },
  { location: 'Virgin Islands, U.S.', continent: 'North America', id: 31536 },
  { location: 'Wales', continent: 'Europe', id: 44575 },
  { location: 'Wallis and Futuna', continent: 'Oceania', id: 14235 },
  { location: 'Western Sahara', continent: 'Africa', id: 32226 },
  { location: 'Yemen', continent: 'Asia', id: 75450 },
  { location: 'Yugoslavia', continent: 'Europe', id: 8168 },
  { location: 'Zambia', continent: 'Africa', id: 44811 },
  { location: 'Zimbabwe', continent: 'Africa', id: 21968 },
];

export default Countries;
